import { Sentry, SentryTeam } from 'lib-shared-sentry';
import { createAuthorizationHeaderValue } from './axiosBaseQuery';
import { ApiErrorStatusCode } from './axiosBaseQuery.types';
/**
 * Adds a response interceptor to handle api errors.
 *
 * @param instance The axios instance.
 */
export function addErrorInterceptors(instance, errorHandlers) {
    instance.interceptors.response.use((response) => response, (error) => {
        if (error.response) {
            const { status } = error.response;
            for (const errorHandler of errorHandlers) {
                if (status === errorHandler.errorCode) {
                    // If a 401 response is received, we want to capture the error in Sentry
                    if (status === ApiErrorStatusCode.Unauthorized) {
                        Sentry.captureMessage('401 unauthorized interceptor', {
                            level: 'debug',
                            tags: {
                                team: SentryTeam.Platform,
                            },
                        });
                        console.error('401 unauthorized interceptor');
                    }
                    errorHandler.handler(instance, error);
                }
            }
        }
        return Promise.reject(error);
    });
}
/**
 * Adds a request interceptor to wait for the refresh token.
 *
 * @param instance The axios instance.
 */
export function addRefreshTokenInterceptor(instance) {
    instance.interceptors.request.use(async (config) => {
        if (config.headers?.['Authorization']) {
            config.headers['Authorization'] = await createAuthorizationHeaderValue();
        }
        return config;
    });
}
//# sourceMappingURL=interceptors.js.map